"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  $(Dom.playButton).on("click", function (event) {
    event.preventDefault();
    var videoID = $(this).attr("data-play-video");
    var videoContainer = $('[data-video="' + videoID + '"]');
    handlers.playVideo(videoID, videoContainer);
  });
};
